
<div class="container">
<app-generic-notification
[titleNotification]="'Autorización para'"
[showCost]="true"
[acceptButton]="true"
[declineButton]="true"
[commentButton]="true"
(responseAutorization)="response($event)"
(addComment)="addComment($event)">
</app-generic-notification>
</div>
